import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {ModalController} from '@ionic/angular';
import {APIService} from 'src/app/API.service';
import {SessionService} from '../services/session.service';
import {AgentService} from '../services/agent.service';
import {ContractStatus} from '../enums/enums';
import {DataStore, SortDirection} from '@aws-amplify/datastore';
import {Contract, PermissionType, User} from '../../models';
import {
    FilePickerComponent
} from '../components/file-picker/file-picker.component';
import {Predicates} from 'aws-amplify';
import {DateTime} from 'luxon';
import {ToastServiceHelperService} from "../services/toast-service-helper.service";

@Component({
    selector: 'app-edit-contract',
    templateUrl: './edit-contract.page.html',
    styleUrls: ['./edit-contract.page.scss'],
})
export class EditContractPage implements OnInit {
    @Input() contractId: string;
    @Input() client: User;
    @Input() commerciale;
    @ViewChild('filePicker') filePickerComponent: FilePickerComponent;
    public currentContract: Contract;
    public emailError = false;
    public clients: User[];
    public commerciali: any[];
    public contractForm: UntypedFormGroup;
    public saveContractButtonText = 'Update';
    public uploadedFile: any;
    public contractStatus = ContractStatus;
    public statusList: any[]; // No way to use Object.values in template...
    public permission;
    private file;


    constructor(
        public sessionService: SessionService,
        public agentService: AgentService,
        public fb: UntypedFormBuilder,
        private toastService: ToastServiceHelperService,
        public modalController: ModalController,
        public apiService: APIService) {
        this.contractForm = this.fb.group({
            'amount': [''],
            'durationInDays': [''],
            'date': [''],
            'notes': [''],
            'client': [''],
            'status': [''],
            'product': [''],
            'startDate': [''],
            'endDate': [''],
            'percent': [''],
            'addedBy': [''],
            'contractYears': [''],
        });

        this.statusList = (Object.values(this.contractStatus)).filter(x => {
            return x;
        });
    }

    async ngOnInit() {
        if (!this.contractId) this.saveContractButtonText = 'Create';
        const currentUser = this.sessionService.getCurrentUser();
        let clientsFilters = c => {
            return true;
        };
        this.permission = currentUser.permessions;
        if (currentUser.permessions == PermissionType.COMMERCIAL)
            clientsFilters = c => {
                return c.addedBy == currentUser.id;
            };
        this.currentContract = this.contractId ? await DataStore.query(Contract, this.contractId) : null;


        this.clients = await DataStore.query(User, Predicates.ALL, {sort: s => s.lastname(SortDirection.ASCENDING).name(SortDirection.ASCENDING)});
        this.clients = this.clients.filter(clientsFilters);
        this.commerciali = await DataStore.query(User,
            u => u.or(x => x.permessions('eq', PermissionType.COMMERCIAL).permessions('eq', PermissionType.ADMINISTRATOR))
            , {sort: s => s.lastname(SortDirection.ASCENDING).name(SortDirection.ASCENDING)});
        let clientId = null;
        let client = null;

        if (this.client?.permessions == PermissionType.CLIENT)
            clientId = this.client;

        if (this.client) {

            client = await DataStore.query(User, this.client.id);
        }

        if (this.currentContract && this.currentContract.clientId) {
            client = await DataStore.query(User, this.currentContract.clientId);
        }


        this.contractForm.setControl('amount', new UntypedFormControl(this.currentContract?.amount));
        this.contractForm.setControl('durationInDays', new UntypedFormControl(this.currentContract?.durationInDays));
        this.contractForm.setControl('date', new UntypedFormControl(this.currentContract?.date));
        this.contractForm.setControl('notes', new UntypedFormControl(this.currentContract?.notes));
        this.contractForm.setControl('addedBy', new UntypedFormControl(this.currentContract?.commercial || this.commerciale));

        this.contractForm.setControl('client', new UntypedFormControl(client));
        this.contractForm.setControl('status', new UntypedFormControl(this.currentContract?.status));
        this.contractForm.setControl('product', new UntypedFormControl(this.currentContract?.product));
        this.contractForm.setControl('startDate', new UntypedFormControl(this.currentContract?.startDate ?? DateTime.now().toISODate()));
        this.contractForm.setControl('endDate', new UntypedFormControl(this.currentContract?.endDate));
        this.contractForm.setControl('percent', new UntypedFormControl(this.currentContract?.percent ?? 10));
        this.contractForm.setControl('contractYears', new UntypedFormControl(this.currentContract?.contractYears?.toString() ?? '1'));

        document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length - 1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
        // setTimeout(() => {
        // }, 1500)
    }

    // onViewDidEnter() {
    //     // make sure the newly styled content scrolls when needed
    //     setTimeout(() => {
    //         document.querySelectorAll('.main-content')[document.querySelectorAll('.main-content').length-1].shadowRoot.querySelector('.inner-scroll').setAttribute('style', 'height:100%');
    //     }, 1500)
    // }

    async saveContract() {
        if (this.currentContract) {
            await this.updateContract();
            // await this.agentService.setAgentLevel(this.currentContract.userContractsAddedId);
            if (this.contractForm.value.status == ContractStatus.ACTIVE) {

            }
        } else {
            const savedContract = await this.createContract();

        }

        this.modalController.dismiss();
    };

    private async updateContract() {

        const original = await DataStore.query(Contract, this.currentContract.id);
        // Do we really need to change client?
        // const client = this.contractForm.value.client ? await DataStore.query(User, this.contractForm.value.client) : null;
        let updateContractDataFirma = false;


        const fileIdentifier: any = await this.storeFile();
        let cl = await DataStore.query(User, this.contractForm.value.client.id);
        this.contractForm.value.endDate = DateTime.fromISO(this.contractForm.value.startDate ?? new Date()).plus({years: parseInt(this.contractForm.value.contractYears)}).toISODate();
        return DataStore.save(Contract.copyOf(original, updated => {
            updated.notes = this.contractForm.value.notes;
            updated.amount = parseFloat(this.contractForm.value.amount);
            updated.date = this.contractForm.value.date;
            //  updated.fileIdentifier = fileIdentifier['key'];
            updated.file = fileIdentifier || original.file || null;
            updated.startDate = this.contractForm.value.startDate;
            updated.endDate = this.contractForm.value.endDate;
            updated.product = this.contractForm.value.product;
            updated.percent = this.contractForm.value.percent;
            updated.status = this.contractForm.value.status;
            updated.clientId = this.contractForm.value.client.id;
            updated.commercial = this.contractForm.value.addedBy;
            updated.contractYears = parseInt(this.contractForm.value.contractYears);

            // updated.userContractsAddedId = this.contractForm.value.addedBy.id;
            //updated.durationInDays = parseInt(this.contractForm.value.durationInDays);
            //updated.client = cl;


        }));
    }

    private async createContract() {
        const fileIdentifier: any = await this.storeFile();

        let client;
        if (this.client) {
            client = this.client;
        } else {
            client = this.contractForm.value.client ? await DataStore.query(User, this.contractForm.value.client.id) : null;

        }

        const currentUser = this.sessionService.getCurrentUser();
        let u = await DataStore.query(User, currentUser.id);

        //  let addedBy = await DataStore.query(User, this.contractForm.value.addedBy);
        //
        this.contractForm.value.endDate = DateTime.fromISO(this.contractForm.value.startDate ?? new Date()).plus({years: parseInt(this.contractForm.value.contractYears)}).toISODate();

        const amount = parseFloat(this.contractForm.value.amount);
        if (Number.isNaN(amount)) {
            await this.toastService.error('Capitale non valido');
            throw new Error('Capitale non valido');
        }
        const createContractInput: Contract = new Contract({
            notes: this.contractForm.value.notes,
            amount: amount,
            date: DateTime.now().toISODate(),
            //   fileIdentifier: fileIdentifier['key'],
            file: fileIdentifier,
            percent: this.contractForm.value.percent,
            startDate: this.contractForm.value.startDate,
            endDate: this.contractForm.value.endDate,
            product: this.contractForm.value.product,
            commercial: this.contractForm.value.addedBy,
            // durationInDays: parseInt(this.contractForm.value.durationInDays),
            clientId: this.contractForm.value.client.id,
            status: this.contractForm.value.status ?? this.contractStatus.DRAFT,
            contractYears: parseInt(this.contractForm.value.contractYears),
        });

        try {
            return await DataStore.save(createContractInput);
        } catch (e) {
            return await this.toastService.error('Capitale non valido');

        }
    }

    private async storeFile() {
        try {
            // const fileToUpload = await fetch(this.uploadedFile);
            // const fileBlob = await fileToUpload.blob();
            // const result = await Storage.put('public/x/' + this.uploadedFile.name, this.uploadedFile);
            // const result = await Storage.put(this.uploadedFile.name, fileBlob, {
            //   // contentType: 'image/png' // contentType is optional
            // });
            if (this.filePickerComponent.isToUpload)
                return await this.filePickerComponent.uploadFile();
            else
                return null;
        } catch (err) {

        }
    }

    fileUploaded($event) {
        this.uploadedFile = $event.target.files[0];

    }


    // @todo Validation
    compareWith(o1: User, o2: User) {
        return o1?.id === o2?.id;
    }

    isValid(field: string) {
        let formField = this.contractForm.get(field);
        return formField.valid || formField.pristine;
    }

    nameValidator(control: UntypedFormControl): { [s: string]: boolean } {
        if (!!control.value) {
            if (!control.value.match('^[a-zA-Z ,.\'-]+$')) {
                return {invalidName: true};
            }
        } else {
            // this.username1 = false;
        }
    }

    changeStatus(status: string) {

    }

    protected readonly PermissionType = PermissionType;
}
